import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import { UpdateParticipant } from "./components/updateParticipant";

const rootElement = document.getElementById("root");
const root = createRoot(rootElement!);
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/update" element={<UpdateParticipant />} />
    </Routes>
  </BrowserRouter>
);
